import React from 'react';
import { useDispatch } from 'react-redux';
import { AppThunkDispatch } from '../stores';
import { localLogout } from '../stores/auth/actions';
import { IconButton } from '@material-ui/core';
import { PowerSettingsNewTwoTone } from '@material-ui/icons';

function LogoutBtn() {
  const dispatch = useDispatch<AppThunkDispatch>();
  return (
    <IconButton size='small' onClick={() => dispatch(localLogout())}>
      <PowerSettingsNewTwoTone />
    </IconButton>
  );
}

export default LogoutBtn;
